import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";

@Component({
  selector: 'page-unit-overview',
  templateUrl: 'unit-overview.html'
})
export class UnitOverviewPage {

  unit:any;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public superTabsCtrl: SuperTabsController
  ) {
    this.unit = navParams.get('unit');
  }

  getUnitStatusText(status){
    switch(parseInt(status)){
      case 1:
        return 'Actief';
      case 9:
        return 'Gerecycleerd'
      case -1:
        return 'Verborgen';
    }
    return 'Actief';
  }

}



// WEBPACK FOOTER //
// ./src/pages/unit-overview/unit-overview.ts